import { createFileRoute } from "@tanstack/react-router";

import Settings from "@/containers/Settings";

export const Route = createFileRoute("/_app/(account)/settings/$tab")({
  component: () => <Settings />,
});
